import { FC, useCallback, useEffect, useRef, useState } from "react";
import { DEFAULT_ITEM_WIDTH, getItemsPerRow, iGrid, ITEMS_GAP } from "./Grid.helpers";
import "./Grid.styles.scss";

const NOOP: iGrid['handleChangeItemsPerRow'] = () => {};

const Grid: FC<iGrid> = (
    {
        itemWidth = DEFAULT_ITEM_WIDTH,
        children,
        maxRowsCount,
        handleChangeItemsPerRow = NOOP,
    }
) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [itemsPerRow, setItemsPerRow] = useState(0);

    const updateItemsPerRow = useCallback(() => {
        if (ref.current) {
            const count = getItemsPerRow(ref.current.offsetWidth, itemWidth);
            setItemsPerRow(count);
            handleChangeItemsPerRow(count);
        }
    }, [itemWidth, handleChangeItemsPerRow]);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const observer = new ResizeObserver(() => updateItemsPerRow());
        observer.observe(el);

        updateItemsPerRow();

        return () => observer.disconnect();
    }, [updateItemsPerRow]);

    const slicedChildren = maxRowsCount ? children.slice(0, maxRowsCount * itemsPerRow) : children;

    return (
        <div className="Grid" ref={ref}>
            {slicedChildren.map((child, index) => (
                <div
                    key={JSON.stringify(child.key)}
                    className={`GridTile appears-left del-${index}`}
                    style={{
                        flexBasis: `calc(calc(100%/${itemsPerRow}) - ${ITEMS_GAP}px)`,
                        maxWidth: `calc(calc(100%/${itemsPerRow}) - ${ITEMS_GAP}px)`
                    }}
                >
                    {child.value}
                </div>
            ))}
        </div>
    );
};

export { Grid };
